<template>
  <div class="cdetail-container" @scroll.prevent>
    <div class="page-header" @touchmove.self.prevent @scroll.prevent>
      <div
        style="height: 50px;width:50px;padding-left:30px;"
        @click="onCloseEvent"
      >
        <img src="../../../static/ic_close.png" alt />
      </div>

      <div class="s8 t1 font-bold">
        {{ subComments.length + '条回复' }}
      </div>
    </div>

    <div class="content-container" @touchmove.self.prevent @scroll.prevent>
      <comment-item
        :item="comment"
        :showDelete="false"
        :showOwner="true"
        @onReplyEvent="onReplyEvent(comment)"
      ></comment-item>
      <div class="line-margin item-line LB2"></div>
      <div class="s10 comments-header" v-if="subComments.length > 0">
        全部评论
      </div>
      <div class="list">
        <div v-for="item in subComments" :key="item.id">
          <comment-item
            :item="item"
            :showOwner="comment.userId == item.userId"
            @onReplyEvent="onReplyEvent(item)"
            @onDeleteEvent="onDeleteEvent(item)"
          ></comment-item>
        </div>
      </div>
      <div :class="spaceClass"></div>
    </div>

    <div
      class="bottom-container"
      v-if="isPermission"
      @touchmove.self.prevent
      @scroll.prevent
    >
      <comment-input
        ref="detail-input"
        :commentsInfo="commentsInfo"
        :comment="currentComment"
        @onInputEvent="onInputEvent"
        @onBlurEvent="onBlurEvent"
        @onCommitEvent="onCommitEvent"
      ></comment-input>
    </div>
  </div>
</template>

<script>
import CommentItem from './CommentItem'
import CommentInput from '@/components/Course/CommentInput'
import { Toast } from 'vant'
// import { hasPermission } from '@/api/permission'
import { isIphone } from '@/api/appInfo'

import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  name: 'CommentDetail',
  data() {
    return {
      currentComment: null
    }
  },

  components: {
    CommentItem,
    CommentInput
  },
  props: {
    commentsInfo: {
      type: Object,
      default: null
    },

    comment: {
      type: Object,
      default: null
    },

    isPermission: {
      type: Boolean,
      default: true
    },
    isShowAll: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('comment', ['subComments']),
    spaceClass() {
      return isIphone() ? 'ios-space' : 'android-space'
    },
    isIphoneState() {
      return isIphone()
    }
  },

  mounted() {
    this.getSubCommentsList()
    console.log(this.isShowAll, 'this.isShowAll')
    this.isShowAll ? (this.currentComment = this.comment) : this.onReplyEvent()
  },

  methods: {
    ...mapActions('comment', [
      'getSubComments',
      'commitComment',
      'deleteComment'
    ]),
    // hasPermission,

    onCommitEvent(content) {
      this.commitComments(content)
    },

    onReplyEvent(comment) {
      if (!this.isPermission) {
        this.$toast('订阅后才可以发布评论哦')
        return
      }
      if (!comment) {
        this.$refs['detail-input'].startInput(this.comment)
      } else {
        this.currentComment = comment
        console.log('this.currentComment:', this.currentComment)
        this.$refs['detail-input'].startInput(comment)
      }
    },

    onInputEvent() {
      this.currentComment = null
    },

    onBlurEvent() {
    },

    onDeleteEvent(item) {
      this.deleteComments(item.id).then(() => {
        this.currentComment = this.comment
      })
    },

    onCloseEvent() {
      this.$emit('onCloseEvent')
    },
    async commitComments(content) {
      let comment = this.comment
      if (this.currentComment) {
        comment = this.currentComment
      }

      const params = {
        topicId: comment.topicId,
        parentCommentId: comment.id,
        content: content
      }
      try {
        this.$toast.loading({
          message: 'loading...',
          forbidClick: true
        })
        const res = await this.commitComment(params)
        this.currentComment = null
        this.$toast.clear()
        if (res.code == 0) {
          Toast('发布成功')
          this.getSubCommentsList().then(() => {
            this.currentComment = this.comment
          })
        } else if (res.code == 403001) {
          Toast(res.msg)
          store.commit('comment/setInputType', 4)
        } else if (res.code == 403002) {
          Toast(res.msg)
          store.commit('comment/setInputType', 1)
        } else if (res.code == 403003) {
          Toast(res.msg)
          store.commit('comment/setInputType', 3)
        } else if (res.code == 403004) {
          Toast(res.msg)
          store.commit('comment/setInputType', 2)
        } else {
          Toast(res.msg)
        }
      } catch (err) {
        // that.$loading.close()
        this.$toast.clear()
      }
    },
    async getSubCommentsList() {
      const params = {
        commentId: this.comment.id,
        direction: 2,
        orderBy: 1
      }

      try {
        await this.getSubComments(params)
      } catch (err) {}
    },
    async deleteComments(commentId) {
      try {
        this.$toast.loading({
          message: '正在删除...',
          forbidClick: true
        })
        const res = await this.deleteComment(commentId)
        store.commit('comment/deleteSubComment', commentId)
        this.$toast.clear()
        if (res.code == 0) {
          Toast('删除成功')
        } else {
          Toast(res.msg)
        }
      } catch (err) {
        this.$toast.clear()
      }
    }
  }
}
</script>

<style scoped>
.cdetail-container {
  height: 100%;
}

.page-header {
  height: 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: #ebebeb solid 1px;
}

.page-header img {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 45px;
}

.content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list {
  height: 100%;
  overflow: auto;
  padding-bottom: 190px;
}

.line-margin {
  margin-top: 30px;
}

.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.android-space {
  height: 320px;
  width: 100%;
}

.ios-space {
  height: 470px;
  width: 100%;
}
.comments-header {
  padding-left: 30px;
  padding-top: 38px;
  padding-bottom: 38px;
  font-weight: bold;
  color: #000000;
}
</style>
